<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Announcements</h2>
      <v-card class="mt-4">
      <Announcements/>
  </v-card>
  </div>
</template>

<script>
import Announcements from '@/components/Utils/Announcements.vue'
  export default {
    components: {
      Announcements
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>